export default class Dish {
    uid = ""
    title = ""
    description = ""
    disabled = 0
    dishcategory = 0
    extra_categories = 0
    price = 0
    allergens = 0    
    status = DishStatus.Unknown
    crdate = 0
}

export enum DishStatus {
    Unknown,
    Available,
    CurrentlyUnavailable,
    IndefinitelyUnavailable
}